import { BugItem, storeToData } from '@/domains/contexts/BugContext'
import { ClockCircleOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FieldTimeOutlined, FileImageOutlined, HistoryOutlined, PaperClipOutlined, ReadOutlined } from '@ant-design/icons'
import {
  Button,
  Form,
  message,
  Select,
  Space,
  Image,
  Tabs,
  Input,
  Table,
  Row,
  Col,
  Divider
} from 'antd'
import styles from './item.module.less'
import { observer, useLocalObservable } from 'mobx-react-lite'
import Add from './Add'
import { KeyboardEvent, useEffect, useRef, useState } from 'react'
import useRequest, { commonReq } from '@/domains/hooks/useLocalRequest'
import { contexts } from '@/domains'
import FileComp from './File'
import CommentList from '@/delivery/components/CommentList'
import { useLocalStorage } from '@/utils/useSparrowLocalStorage'
import DeliveryTag from '@/delivery/components/DeliveryTag'
import TruncatedText from '@/components/TruncatedText/index';
import { formatTimeDifference } from '@/utils/S'
import moment from 'moment'
import UserIcon from '@/components/UserIcon/UserIcon'

const { TextArea } = Input
const { Option } = Select
type Props = {
  item: BugItem
  i: number
}
const { BugContext } = contexts

export const Header = observer((props: Props) => {
  const { item, i } = props
  const { statusList, getList, deliveryMap,handleQueryOperationListById } = BugContext.useContainer()
  const editReq = useRequest('/sparrowBug/updateBug')
  
  const handleChange = (param) => {
    commonReq(async (handleErr) => {
      const params = {
        updateBugDetailList: [
          {
            ...storeToData(item),
            ...param
          }
        ]
      }
      const res = await editReq.run(params)
      if (res.success && res.result) {
        message.success('修改成功')
        getList()
      } else {
        handleErr()
      }
    }, '修改失败，清稍后重试')
  }
  const taskName = deliveryMap[item.taskId]?.taskName
  return (
    <Space className='w-full bug-list-item'>
      <Row justify="space-between" className='w-full'>
           <Col>
                <Space direction='horizontal' style={{height:32}}> 
                    <div className='bug-index'>#{i + 1}</div>
                    {!!taskName && (
                      <div>
                        <DeliveryTag>{taskName}</DeliveryTag>
                      </div>
                    )} 
                    <TruncatedText text={item.title}  width={'300px'} /> 
                </Space>
           </Col>
           <Col>
                <Space direction='horizontal'  style={{height:32}}>
                      <div className='proposal-member'>
                        {/* <span>提报人：</span> */}
                        <UserIcon effect='post' id={item.fromUser}></UserIcon>
                      </div>
                      <Divider type="vertical"  />
                      <div className='execute-member'>
                        {/* <span>跟进人：</span> */}
                        <Space size={0}>
                          {item.userList.map((item, index) => (
                            <UserIcon effect={index == 0 ? 'leader' : null} id={item.id} key={item.id}></UserIcon>
                          ))}
                        </Space>
                      </div>
                      <div onClick={(e) => e.stopPropagation()}>
                        {/* BUG状态快捷选择 */}
                        <Select
                          value={item.status}
                          onChange={(e) => {
                            handleChange({
                              bugStatus: e
                            })
                          }}
                          className={`sp-bug-status-select is-${item.status}`}
                        >
                          {statusList.map((item) => {
                            return (
                              <Option
                                key={item.status}
                                value={item.status}
                                className={`sp-bug-status-select-item is-${item.status}`}
                              >
                                {item.name}
                              </Option>
                            )
                          })}
                        </Select>
                      </div>  
                </Space>
               
           </Col>
        </Row> 
    </Space>
  )
})
const Item = (props: Props) => {
  const { item, i } = props
  const { id } = item
  const {
    deliveryMap,
    getList,
    commentListMap,
    handleQueryCommentListByTargetIds,
    handleCreateComment,
    currOperationInfos,
    handleQueryOperationListById
  } = BugContext.useContainer()
  const store = useLocalObservable(() => ({
    currTab: 'comment',
    comment: '',
    isFocus:false,
  }))
  const [token, setToken] = useLocalStorage<string>({
    key: 'token'
  })
  const [showAdd, setShowAdd] = useState(false)
  const deleteReq = useRequest('/sparrowBug/deleteBug') 

  const inputRef = useRef<HTMLTextAreaElement>(null)
  const isComposingRef = useRef(false)

  useEffect(() => {
    handleQueryOperationListById(id)
  }, [id])

  const handleCommentChange = (e) => {
    store.comment = e.target.value
  }

  const handleFocus = () => {
    store.isFocus = true
  }

  const handleBlur = () => {
    store.isFocus = false
  }

  const handleDelete = () => {
    commonReq(async (handleErr) => {
      
      const res = await deleteReq.run({
        id: id
      })
      if (res.success && res.result) {
        message.success(`删除成功`)
        getList()
      } else {
        handleErr()
      }
    }, `删除失败，清稍后重试`)
  }
  
  const insertCommentNewline = (el: HTMLTextAreaElement) => {
    const { selectionStart, selectionEnd, value } = el
    const next = `${value.slice(0, selectionStart)}\n${value.slice(selectionEnd)}`
    store.comment = next
    const cursor = selectionStart + 1
    requestAnimationFrame(() => {
      el.selectionStart = cursor
      el.selectionEnd = cursor
    })
  }

  const handleCommentPressEnter = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (isComposingRef.current || e.nativeEvent.isComposing) {
      return
    }
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault()
      insertCommentNewline(e.currentTarget)
      return
    }
    if (e.shiftKey) {
      return
    }
    e.preventDefault()
    e.stopPropagation()
    handleComment()
  }

  const handleComment = () => {
    if (!store.comment?.trim()) {
      message.error('评论不能为空')
      return
    }
    const payload = {
      content: store.comment.trim(),
      targetId: String(id),
      targetType: 'SPARROW',
      toUserId: '0'
    }
    handleCreateComment(payload).then((res) => {
      if (res) {
        store.comment = ''
        handleQueryCommentListByTargetIds()
      }
    })
  }
  return (
    <div>

      <Space className="w-full" size={15} direction="vertical"> 
          <Row>
              <Col span={12} className='bugcard_right_content icon-info-list-container'>
                  <Row className='first-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <ClockCircleOutlined/>
                          </Col>
                          <Col span={21} style={{paddingRight:20}}>
                              <span className="">{moment(item.onlineDate).format('YYYY年MM月DD日 hh:mm')}</span>
                          </Col>
                  </Row>
                  <Row className=''>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <ReadOutlined  />
                          </Col>
                          <Col span={21} style={{paddingRight:20}}>
                               <span style={{ whiteSpace: 'pre-wrap' }}>{item.title}</span>
                          </Col>
                  </Row>
                  <Row className=' '>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <FileImageOutlined />
                          </Col>
                          <Col span={21}>
                                  {!item.imgs.length && <span>没有图片描述</span>}
                                  <div className={styles.fileContianer}>
                                    <Image.PreviewGroup>
                                      {item.imgs
                                        .filter((item) => item.isImg)
                                        .map((item, i) => (
                                          <div className={styles.fileItem} key={item.url + i}>
                                            <Image src={item.url} width={80} height={80} />
                                          </div>
                                        ))}
                                    </Image.PreviewGroup>
                                    {item.imgs
                                      .filter((item) => !item.isImg)
                                      .map((item, i) => (
                                        <div className={styles.fileItem} key={item.url + i}>
                                          <FileComp
                                            item={item}
                                            action="preview"
                                            onAction={(e) => window.open(item.url)}
                                          />
                                        </div>
                                      ))}
                                  </div>
                          </Col>
                  </Row>
                  <Row className='last-row'>
                          <Col span={1}></Col>
                          <Col span={2}>  
                              <EyeOutlined  />
                          </Col>
                          <Col span={21} className='event-list'>
                              {
                                // 操作日志
                                currOperationInfos.map( (operation)=>(
                                      <div key ={operation.id}> 
                                        <span className='name-hint'>{operation.userName?operation.userName:'未知'} </span>
                                        <span>{operation.content}</span>
                                        <span className='time-desc'>{operation.eventTime?formatTimeDifference(operation.eventTime):''} </span>
                                      </div> 
                                  )
                                )
                              } 
                          </Col>
                  </Row> 
              </Col>
              <Col span={4} className='edit-operation-area-middle'>
                    <Space size={0}>
                            <Button
                              type="link"
                              icon={<EditOutlined />}
                              onClick={(e) => {
                                e.stopPropagation()
                                setShowAdd(true)
                              }}
                            >
                              编辑
                            </Button>
                            <Button
                              type="link"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={(e) => {
                                e.stopPropagation()
                                handleDelete()
                              }}
                            >
                              删除
                            </Button>
                    </Space>
              </Col>
              <Col span={8}  className='bugcard_left_content'>
                  <div className="flex flex-col" style={{ padding: '0 20px' }}>
                    <TextArea
                      allowClear
                      ref={inputRef}
                      autoSize={{ minRows: 1, maxRows: 2 }}
                      placeholder="Enter 发送，Ctrl/⌘ + Enter换行"
                      value={store.comment}
                      onFocus={handleFocus}
                      onBlur={handleBlur}
                      onChange={handleCommentChange}
                      onCompositionStart={() => {
                        isComposingRef.current = true
                      }}
                      onCompositionEnd={() => {
                        isComposingRef.current = false
                      }}
                      onPressEnter={handleCommentPressEnter}
                      className="comment-content-input"
                      onClick={(e) => e.stopPropagation()}
                    />
                    <div style={{textAlign:'left',fontSize:13, paddingBlock:12}}>评论({commentListMap[id]? commentListMap[id].length : 0})</div>
                    <CommentList newDataSource={null} oldDataSource={commentListMap[id] || []} />
                  </div>
              </Col>
          </Row> 
      </Space> 
      <Add visible={showAdd} setVisible={setShowAdd} isEdit item={item}></Add>
    </div>
  )
}

export default observer(Item)
